<div class="row">
	<div class="col-sm-6">
		<div class="c-form-group">
			<div class="c-form-group__label">
				<label for="regionMargin">Region Margin</label>
			</div>
			<input id="regionMargin" cclFormInput type="text" class="c-form-group__input c-input--required" [(ngModel)]="regionConfig.margin">
			<div class="c-form-group__hint">&nbsp;</div>
		</div>
	</div>
	<div class="col-sm-6">
		<div class="c-form-group">
			<div class="c-form-group__label">
				<label for="regionPadding">Region Padding</label>
			</div>
			<input id="regionPadding" cclFormInput type="text" class="c-form-group__input c-input--required" [(ngModel)]="regionConfig.padding">
			<div class="c-form-group__hint">&nbsp;</div>
		</div>
	</div>
	<div class="col-sm-6">
		<div class="c-form-group">
			<div class="c-form-group__label">
				<label for="backgroundColor">Background Color</label>
			</div>
			<div class="input-group" [(colorPicker)]="regionConfig.background" [cpAlphaChannel]="'disabled'" [cpOutputFormat]="'hex'">
				<input id="backgroundColor" cclFormInput type="text" [(ngModel)]="regionConfig.background" class="c-form-group__input form-control">

				<div class="input-group-append">
					<span class="c-color-picker input-group-text" [ngStyle]="{'background-color': regionConfig.background}">&nbsp;</span>
				</div>
			</div>

			<div class="c-form-group__hint">&nbsp;</div>
		</div>
	</div>
	<div class="col-sm-6">
		<div class="c-form-group">
			<div class="c-form-group__label">
				<label for="roundedCorners">Rounded Corners</label>
			</div>
			<input id="roundedCorners" cclFormInput type="text" class="c-form-group__input c-input--required" [(ngModel)]="regionConfig.corner">
			<div class="c-form-group__hint">&nbsp;</div>
		</div>
	</div>
</div>